////////////////////////////////////////
// WhooosReadingUtility.js /////////////
////////////////////////////////////////
// Referenced elsewhere as $wr /////////
////////////////////////////////////////

var moment = require('moment');
var ReactDOM = require("react-dom");
// Note: CurrentUser reqired below

var WhooosReadingUtility = {
	// Take the location of an image with within the /public/images directory
	//	Note: This is set up as its own function to make it easier to change it's behavior
	//	in production if we need to

	redirect: function(path) {
		window.redirectWorkaround(path);
	},

	didParamsChange: function(propsA, propsB) {
		if (propsA.match && propsA.match.params && propsB.match && propsB.match.params) {
			return !_.isEqual(propsA.match.params, propsB.match.params);
		}
	},

	getOrdinal: function(n) {
		n = parseInt(n);
		var s = ["th", "st", "nd", "rd"];
		var v = n % 100;
		return n + (s[(v - 20) % 10] || s[v] || s[0]);
	},

	isValidDayOfWeek: function(n) {
		if (n < 0 || n > 6) {
			return false 
		} else {
			return true
		}
	},

	getDayOfWeek: function(n) {
		n = parseInt(n);
		if (n < 0 || n > 6) {
			throw "Invalid Day of Week";
		} else {
			return $wr.Constants.DAYS_OF_WEEK[n];
		}
	},

	padleft: function(n, width, padWith) {
		padWith = padWith || "0";
		var nString = n + "";
		if (nString.length < width) {
			return new Array(width - nString.length + 1).join(padWith) + n;
		} else {
			return nString;
		}
	},

	numberWithCommas(n) {
		if (n) {
			return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");			
		} else {
			return 0;
		}
	},

	centsToDollars(cents, dollarsOnly) {
		if (cents != undefined) {
			if (dollarsOnly) {
				return "$" + $wr.numberWithCommas(Math.floor(cents / 100));
			} else {
				var dollarPart = "$" + $wr.numberWithCommas(Math.floor(cents / 100))
				var centsPart = (cents / 100).toFixed(2).split(".")[1];
				return dollarPart + "." + centsPart;
			}			
		}
	},

	momentInTimezone(date) {
		var format = "YYYY-MM-DD HH:mm:ss"

		// Move it here to avoid issues requiring this file elsewhere
		var CurrentUser = require('lib/account/CurrentUser');

		if (CurrentUser.isSignedIn()) {
			var offset = CurrentUser.get().time_zone_offset / (60 * 60);
			if (date == undefined) {
				return moment().utcOffset(offset);
			} else {
				return moment.utc(date, format).utcOffset(offset);
			}
		} else {
			// Default to Pacific time
			return moment.utc(date, format).utcOffset(-7);
		}
	},

	sortByName(grouping, listType) {
		if (listType == $wr.Constants.FIELDS.STUDENTLIST) {
			return _.sortBy(grouping, function(s){ return s.name })

		} else if (listType == $wr.Constants.FIELDS.FIRSTNAME) {
			return _.sortBy(grouping, function(s){ return s.first_name })

		} else if (listType == $wr.Constants.FIELDS.LASTNAME) {
			return _.sortBy(grouping, function(s){ return s.last_name })

		} else if (listType == $wr.Constants.FIELDS.BOOKTITLE) {
			return _.sortBy(grouping, function(b){ return b.title })

		} else if (listType == $wr.Constants.FIELDS.FLEXNAME) {
			return _.sortBy(grouping, function(s) {
				if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
					return s.first_name;
				} else {
					return s.last_name + ", " + s.first_name;
				}
			});

		} else if (listType == $wr.Constants.FIELDS.FLEXNAMEDEMOFIRST) {
			return _.sortBy(grouping, function(s) {
				if (s.demo_for_teacher) {
					return "A";
				} else if (s.last_name == $wr.Constants.FILLER_LAST_NAME) {
					return s.first_name;
				} else {
					return s.last_name + ", " + s.first_name;
				}
			});

		} else {
			throw "Unrecognized List Type";
		}
	},

	formatDateTime: function(date, yearOption) {
		var tzDate = this.momentInTimezone(date);
		if ((yearOption == "show-past-years") && (tzDate.year() != moment().year())) {
			return tzDate.format("MMM D YYYY, h:mm a");			
		} else {
			return tzDate.format("MMM D, h:mm a");
		}
	},

	formatDate: function(date, format) {
		if (date) {
			format = format || "MMM D, YYYY";
			return this.momentInTimezone(date).format(format);			
		}
	},

	formatTime: function(date) {
		if (date) {
			return this.momentInTimezone(date).format("h:mm a");
		}
	},

	//Format a date without taking timezone offset into account
	formatDateWithoutTimezone: function(date, format) {
		if (date){
			return moment(date).format(format)
		}
	},

	fetchSlicedItems: function(array, maxSize) {
		var lists = [[]];
		var array = array;

		for (var i=0; i<array.length; i++) {
			if (_.last(lists).length >= maxSize) {
				lists.push([]);
			}
			_.last(lists).push(array[i]);
		}
		return lists;
	},

	displayBackground: function(background) {
		// If the background is being previewed in the shop, perks is just the background that
		// is to be previewed.
		if (background == "") {return}
		var $container = $(".outerPageContainer");
		var name = background.toLowerCase();
		var perkPath = dynamicRequire("perks/backgrounds/" + name + ".png");
		$container.addClass("hasBackground").css('background', 'url(' + perkPath + ')');
	},

	removeBackground: function(){
		var $container = $(".outerPageContainer");
		$container.removeClass("hasBackground").css('background', '#fff');
	},

	hasBackgroundEquipped: function(perks){
		return perks.find( perk => {
			return perk.perk_type == "backgrounds" && perk.equipped
		})
	},

	fetchTitle: function(student, onlyFirstName) {
		if (onlyFirstName) {
			if (student.perks.titles) {
				return (student.perks.titles + " " + student.first_name);
			} else {
				return student.first_name
			}
		} else {
			if (student.perks.titles) {
				return (student.perks.titles + " " + student.display_name);
			} else {
				return student.display_name
			}
		}
	},

	getShopOpeningTime: function(user) {
		var prefs = user.prefs || {};
		return prefs.shop_opening_time || "Always";
	},

	shouldShopOpen: function(user) {
		var prefs = user.prefs || {};
		var openingTime = prefs.shop_opening_time || "Always";
		if (openingTime != undefined) {
			if (openingTime == "Never") {
				return false;
			}
			var currentTime = new Date();
			var weekDay = currentTime.getDay();
			if (openingTime != "Always" && weekDay > 0 && weekDay < 6) {
				var openHour = parseInt(openingTime.split(" ")[0]) + 12;
				var openingDate = new Date();
				openingDate.setHours(openHour);
				openingDate.setMinutes(0);

				if (currentTime < openingDate) {
					return false;
				}
			}
		}
		return true;
	},

	canStudentTakeQuiz: function(user){
		var prefs = user.prefs || {};
		var closeTime = prefs.quiz_close_time || "Never";
		//  always can take quiz if never close or undefined close time.
		if (closeTime == "Never" || closeTime == undefined){
			return true
		} else if (closeTime == "Always") {
			return false
		}
		//student hour and day 
		var currentHourAndDay = moment().tz(user.time_zone_region).format('h a d').split(" ")
		
		var weekDay = parseInt(currentHourAndDay[2]);
		var currentHour = parseInt(currentHourAndDay[0]);
		
		//if its the weekend, quizzes are closed because closing time is defined here
		if (weekDay > 0 && weekDay < 6) {
			var closingHour = parseInt(closeTime.split(" ")[0]) + 12;
			
			// Need to handle edge case for 12am/pm separately
			if (currentHour == 12){
				if (currentHourAndDay[1] == "am"){
					currentHour = 0
				}
			} else {
				//add time offset for pm
				if (currentHourAndDay[1] == "pm"){
					currentHour += 12
				}
			}

			if (currentHour < closingHour) {
				return true;
			} else {
				return false;
			}
		}
		//it's the weekend.
		else { return false }
	},

	// Can handle arrays, functions, objects, and basic types (like numbers and strings)
	checkComplexObjectEquals: function(itemA, itemB) {
		if (_.isArray(itemA)) {
			// itemB also has to be an array
			if (!_.isArray(itemB)) { return false; }

			// itemB should have the same length
			if (itemA.length != itemB.length) { return false; }

			// Every element in itemB should be the same as the element in itemA
			for (var i = 0; i < itemA.length; i++) {
				if (!this.checkComplexObjectEquals(itemA[i], itemB[i])) {
					return false;
				}
			}
			return true;

		} else if (_.isFunction(itemA)) {
			// itemB also has to be a function
			if (!_.isFunction(itemB)) { return false; }

			// No better way to compare functions
			return itemA == itemB;

		} else if (_.isObject(itemA)) {
			// itemB also has to be an object
			if (!_.isObject(itemB)) { return false; }

			var keys = _.keys(itemA);

			// They should have the same number of keys
			if (keys.length != _.keys(itemB).length) { return false }

			// Every value in itemB should be the same as the value in itemA
			for (var i = 0; i < keys.length; i++) {
				if (!this.checkComplexObjectEquals(itemA[keys[i]], itemB[keys[i]])) {
					return false;
				}
			}
			return true;

		} else {
			// === should work well for basic data types.
			// === catches differences between null and underfined
			return itemA === itemB;
		}
	},

	sortedJSON: function(obj) {
		var output = {};
		_.each(_.sortBy(_.keys(obj)), (key) => {
			output[key] = obj[key];
		});
		return JSON.stringify(output);
	},

	// Build a handler that provides default behavior for 401, 403, 404, and 500 errors
	// Use only for users that are signed in
	//   401 Error: Redirect to login page with error explaining they've been
	//		logged off. On successful login, redirect to the desired page
	//   403 Error: Redirect to profile with error explaining they can't visit
	//		the page they were trying to view
	//   404 Error: Redirect to profile with error explaining they can't view
	//		the page they were trying to view
	//   400 Error: Don't redirect. Explain that something went wrong with the client
	//		and they should try to refresh the page or come back later
	//   500 Error: Don't redirect. Explain that something went wrong on the server
	//		and they should try to refresh the page or come back later

	apiHandler: function(expectedCallback, onError) {
		return function(responseJSON, success, statusCode, jqXHR) {
			
			switch(statusCode) {
			case 401:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("You've been logged out!", "Log in to see the page you were trying to view.");
				this.redirect("/login");
				break;

			case 403:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("Sorry!", "You can't view this page");
				this.redirect("/");
				break;

			case 404:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("Sorry!", "You can't view this page");
				this.redirect("/");
				break;

			case 400:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("Something went wrong, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				if (onError) { onError() }
				break;

			case 500:
				console.log("WR Api Error " + statusCode, jqXHR);
				// This probably wasn't on a route load because we should have caught that in the route onEnter
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... try refreshing the page or trying again later.");
				if (onError) { onError() }
				break;

			case 502:
			case 503:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("Something went wrong on our end, sorry!", "This is embarrassing for us... one of our servers seems to have gone down. Please try again later!");
				if (onError) { onError() }
				break;

			case 504:
				console.log("WR Api Error " + statusCode, jqXHR);
				displayAlert("Something went wrong on our end, sorry!", "Too many people are using WR right now! We are working on it now. Please try again later!");
				if (onError) { onError() }
				break;

			default:
				// do the right thing if it's 2xx
				if ((statusCode >= 200) || (statusCode < 300) && (responseJSON != undefined)) {
					expectedCallback(responseJSON, success, statusCode, jqXHR);
				} else {
					try {
						expectedCallback(responseJSON, success, statusCode, jqXHR);
					} catch(error) {
						console.error(error);
					}
					if (responseJSON == undefined) {
						console.error("Response JSON is undefined, Status Code: " + statusCode)
					} else {
						console.error("Uncaught Status Code: " + statusCode)
					}
				}
			}
		}.bind(this);
	},

	pluralize: function(string, count, pluralForm) {
		if (pluralForm == undefined) {
			pluralForm = string + "s";
		}
		return (count == 1 ? string : pluralForm);
	},

	pluralizeWithNumber: function(string, count, pluralForm) {
		return count + " " + $wr.pluralize(string, count, pluralForm);
	},

	capitalize: function(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},


	toSentence: function(items) {
		return _.reduce(items, function(memo, item, index) {
			if (index == items.length - 1) {
				// We know there are at least 2 elements, since we didn't pass an inital memo
				return memo + (items.length > 2 ? ", and " : " and ") + item;
			} else {
				return memo + ", " + item;
			}
		});
	},

	isValidEmail: function(email) {
		const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return EMAIL_REGEX.test(email);
	},

	hashCode: function(text) {
		var hash = 0;

		if (text.length === 0) { return hash; }

		for (var i = 0; i < text.length; i++) {
			var chr = text.charCodeAt(i);
			var hash = ((hash << 5) - hash) + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	},

	psuedoRandom: function(seed, limit) {
		if (typeof seed == "string") {
			seed = $wr.hashCode(seed);
		}
		var x = Math.sin(seed) * 10000;
		var y = x - Math.floor(x);

		if (limit === undefined) {
			return y;
		} else {
			return Math.floor(y * limit);
		}
	},

	randomString: function(length) {
		// Thanks @csharptest.net
		// https://stackoverflow.com/a/1349426/4557470
		var result           = '';
		var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		var charactersLength = characters.length;
		for (var i = 0; i < length; i++) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
		}
		return result;
	},

	getInnerText: function(obj) {
		var buf = "";
		if (obj) {
			var type = typeof(obj);
			if (type === "string" || type === "number") {
				buf += obj;
			} else if (type === 'object') {
				var children = null;
				if (Array.isArray(obj)) {
					children = obj;
				} else {
					var props = obj.props;
					if (props) {
						children = props.children;
					}
				}
				if (children) {
					if (Array.isArray(children)) {
						children.forEach(function(o) {
							buf += this.getInnerText(o);
						}.bind(this));
					} else {
						buf += this.getInnerText(children);
					}
				}
			}
		}
		return buf;
	},
	
	preventDefaultBehavior: function(e) {
		e.preventDefault()
	},
	nope(e) {
		if (e) { e.preventDefault(); }
	},
	print: function(e) {
		$wr.nope(e);
		window.print()
	},

	notImplemented() {
		throw "Not Implemented!";
	},

	loadScript(url, checkKey, callback) {
		window.wr_loadScriptFetching = window.wr_loadScriptFetching || {};

		if (window[checkKey] !== undefined) {
			// Immediately go back to the callback
			setTimeout(callback, 0);

		} else if (window.wr_loadScriptFetching[checkKey]) {
			// Recurse on loadScript till it loads in from the other call
			setTimeout(() => { 
				$wr.loadScript(url, checkKey, callback)
			}, 250);


		} else {
			window.wr_loadScriptFetching[checkKey] = true;

			// Fetch the script, use the callback on return
			$.ajax({
				url: url,
				dataType: 'script',
				success: callback,
				async: true
			});
		}
	},

	triggerResize() {
		$(window).trigger("resize");
	},

	repeatedTriggerResize() {
		setTimeout(this.triggerResize, 10);
		setTimeout(this.triggerResize, 100);
		setTimeout(this.triggerResize, 500);
		setTimeout(this.triggerResize, 1000);
		setTimeout(this.triggerResize, 2000);
		setTimeout(this.triggerResize, 3000);
		setTimeout(this.triggerResize, 5000);
	},

	isProduction() {
		return process.env.NODE_ENV === "production";
	},
	isDevelopment() {
		return process.env.NODE_ENV === "development";
	},
	isStaging() {
		return process.env.NODE_ENV === "staging";
	},
	environment() {
		return process.env.NODE_ENV;
	},
	isAppdev() {
		return process.env.APPDEV == "true";
	},

	checkCustomEnv(key) {
		if (this.isDevelopment() && process.env.CUSTOM_ENV) {
			if (window.wrCustomEnv == undefined) {
				window.wrCustomEnv = JSON.parse(process.env.CUSTOM_ENV)
			}
			return window.wrCustomEnv[key];
		}

	},

	isInternetExplorer() {
		var msIndex = window.navigator.userAgent.indexOf("MSIE ");
		return msIndex > 0;
	},

	isSafari() {
		var safariVar1 = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0
		var safariVar2 = (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
		return safariVar1 || safariVar2;
	},

	isIOS() {
		return (/iPad|iPhone/).test(navigator.userAgent);
	},

	findAllValues(searchObj, targetKey) {
		var helperF = function(obj, values) {
			_.each(_.keys(obj), function(key) {
				if (targetKey == key) {
					values.push(obj[key]);
				} else {
					helperF(obj[key], values);
				}
			});			
		}
		var accumulator = [];
		helperF(searchObj, accumulator);
		return accumulator;
	},

	initInactivityTimer() {
		window.wrInactivityTimer = new Date();
		document.onmousemove = function() {
			window.wrInactivityTimer = new Date();
		}
	},
	isInactive(seconds) {
		if (seconds == undefined) {
			seconds = 200;
		}

		var msDiff = new Date() - window.wrInactivityTimer;

		return (msDiff / 1000) >= seconds;
	},

	getURLParameterByName(name) {
		var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
		return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	},
	getQueryObject(fullURL) {
		if (fullURL == undefined) {
			fullURL = window.location.href;
		}
		var queryIndex = fullURL.indexOf("?");
		if (queryIndex == -1) {
			return {};
		}
		var query = fullURL.substring(queryIndex + 1);
		// Thanks @ Wolfgang Kuehn
		// https://stackoverflow.com/a/8649003/4557470
		return JSON.parse('{"' + decodeURI(query).
			replace(/"/g, '\\"').
			replace(/&/g, '","').
			replace(/=/g,'":"') + '"}');
	},

	getNormalizedPath(url) {
		var el = document.createElement('a');
		el.href = url;

		var path = el.pathname;
		path = path.replace(/\/\d+/g, "/*");

		return path;
	},

	scrollToElement(element, offset) {
		offset = offset || 0;
		var $element = $(element);
		if ($element.length > 0) {
			$("html, body").animate({ scrollTop: $element.offset().top - offset }, "slow");
		}
	},
	setWindowY(scrollTop) {
		$("html, body").scrollTop(scrollTop);
	},

	toBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		})
	},

	componentToText(component) {
		var tempDiv = document.createElement("div")
		ReactDOM.render(component, tempDiv)
		return tempDiv.innerText;
	},

	getJSON(url, onSuccess) {
		this.requestJSON(url, null, 'GET', onSuccess);
	},
	postJSON(url, data, onSuccess, onFailure) {
		this.requestJSON(url, data, 'POST', onSuccess, onFailure);
	},
	patchJSON(url, data, onSuccess) {
		this.requestJSON(url, data, 'PATCH', onSuccess);
	},
	deleteJSON(url, onSuccess) {
		this.requestJSON(url, null, 'DELETE', onSuccess);
	},
	requestJSON(url, data, type, onSuccess, onFailure) {
		this.remoteRequest(url, data, type, "json", onSuccess, onFailure);
	},
	remoteRequest(url, data, type, dataType, onSuccess, onFailure) {
		$.ajax({
			url: url, dataType: dataType, type: type, data: data, success: onSuccess,
			error: function(xhr, status, err) {
				console.error(url, status, err.toString());
				if (onFailure) {
					onFailure();
				}
			}
		});
	},
	altRemoteRequest(url, method, data, callback) {
		var options = {
			type: method,
			async: true,
			contentType: "application/json",
			dataType: "json",
			processData: true
		};
		if (data) {
			options["data"] = JSON.stringify(data);
		}
		var request = $.ajax(url, options);
		request.fail(function(jqXHR, textStatus, errorThrown){
			if (callback) {
				callback(jqXHR.responseJSON, false, jqXHR.status, jqXHR);
			}
		});

		request.done(function(response, textStatus, jqXHR){
			if (callback) {
				callback(response, true, jqXHR.status, jqXHR);
			}
		});
	},
	truncate(string, charLimit) {
		if (string) {
			return string.length > charLimit ? `${string.substring(0, charLimit)}...` : string;
		}
	},
	// TODO: standardize FE requests
	isLargeRequest(userIDs) {
		return userIDs !== undefined ? userIDs.length > $wr.Constants.ACCOUNT_SIZE.LARGE_ACCOUNT_LIMIT : false
	},
	handleLargeRequest(dispatch, userIDs, conditions, actionFunction, options, callback) {
		var chunkedUsers = _.chunk(userIDs, $wr.Constants.ACCOUNT_SIZE.REQUEST_CHUNK_SIZE)
		var promiseArray = [];

		_.each(chunkedUsers, (userIDs, i) => {
			conditions = _.extend(conditions, { userIDs: userIDs, noPagination: true })
			options.conditions = conditions
			promiseArray.push(dispatch(actionFunction(options)));
			// return dispatch(actionFunction(options));

			if (i + 1 === chunkedUsers.length) {
				if (callback && typeof callback === 'function') {
					callback(promiseArray);
				} else {
					return _.compact(promiseArray);
				}
			}
		})
	},
	frontEndPaginationTotal(stateObj) {
		return _.size(_.compact(_.map(_.keys(stateObj), (key) => { if (stateObj[key] && stateObj[key]['id']) { return stateObj[key] } })))
	},
	toTitleCase(str) {
		return str.replace(/\w\S*/g,
			function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			}
		);
	},

	// gets items that the user can afford
	canAffordItem(userCoins, currentTier, allItems, category, type)  {
		if (category=="patch") {
			var items = _.select(allItems, function(patch) {
				//removes duplicates by removing right hand and body 2 items
				var handType = patch.origin_patch_type == "hand" ? "left_hand" : patch.patch_type; 
				var bodyType = patch.origin_patch_type == "body" ? "body" : patch.patch_type;
				return patch.price <= userCoins && !patch.owned && patch.source == "store" && patch.tier == currentTier
				&& (patch.patch_type == type);
			});
		} else if (category=="perk") {
			if (type == "total") {
				var items = _.select(allItems, function(perk) {
					return perk.price <= userCoins && !perk.owned && perk.source == "store" && perk.tier == currentTier 
				});
			} else {
				var items = _.select(allItems, function(perk) {
					return perk.price <= userCoins && !perk.owned && perk.source == "store" && perk.tier == currentTier 
					&& perk.perk_type==type
				});
			}
			
		} else {
			var items = _.select(allItems, function(furniture) {
				return furniture.perk_type == type && furniture.price <= userCoins && !furniture.owned && furniture.source == "store" 
				&& furniture.tier == currentTier
			});
		}

		return items;
	},  

	// returns the number of reqs remaining to level up, by type
	getRemainingReqs(tier, reqs, patches, perks, furnitures) {
	if (!reqs) {return}
        var reqsRemaining = Object()

        if (reqs.patches){
            for (var [patch_type, count] of Object.entries(reqs.patches)){
                var requiredPatchesOwned = _.filter(patches, patch=>{
                    return (patch.owned && tier == patch.tier && patch_type == patch.patch_type)
                })

                var remaining = count - Math.min(count, requiredPatchesOwned.length)
                if (remaining > 0) reqsRemaining[patch_type] = remaining
            }
        }
        if (reqs.perks){
            for (var [perk_type, count] of Object.entries(reqs.perks)){
                var requiredPerksOwned
                
                if (perk_type == "total"){
                    requiredPerksOwned = _.filter(perks, perk=>{
                        return (perk.owned && tier == perk.tier)
                    })
                }
                else {
                    requiredPerksOwned = _.filter(perks, perk=>{
                        return (perk.owned && tier == perk.tier && perk_type == perk.perk_type)
                    })
                }
                remaining = count - Math.min(count, requiredPerksOwned.length)
                if (remaining > 0) reqsRemaining[perk_type] = remaining
            }
        }

        if (reqs.furnitures) {
            for (var [furniture_type, count] of Object.entries(reqs.furnitures)){
                var requiredFurnitureOwned = _.filter(furnitures, furniture=>{
                    return (furniture.owned && furniture_type == furniture.origin_perk_type && tier == furniture.tier )
                })

                remaining = count - Math.min(count, requiredFurnitureOwned.length)
                if (remaining > 0) reqsRemaining[furniture_type] = remaining
            }
        }
        return reqsRemaining
	},
	
	// converts score based on user preferences
	convertedScore(ratio, displayScoreCap) {
		displayScoreCap = displayScoreCap || 4
		
		var score = ratio * displayScoreCap;
		// Round down to nearest 0.5
		score = Math.floor(score * 2) / 2;

		return score;
	},


	Constants: {
		BASE_TITLES: ["Mr.", "Ms.", "Mrs.", "Miss", "Dr."],
		FILLER_LAST_NAME: "Owlsomestudent",
		PERIODS: {
			WEEK: "week",
			MONTH: "month",
			QUARTER: "quarter",
			TRIMESTER: "trimester",
			SEMESTER: "semester",
			SCHOOL_YEAR: "school-year",
			ALLTIME: "all-time"
		},
		DAYS_OF_WEEK: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
		FIELDS: {
			STUDENTLIST: "studentList",
			FIRSTNAME: "firstName",
			LASTNAME: "lastName",
			BOOKTITLE: "bookTitle",
			FLEXNAME: "flexName",
			FLEXNAMEDEMOFIRST: "flexNameDemoFirst"
		},
		ACCOUNT_SIZE: {
			LARGE_ACCOUNT_LIMIT: 30,
			REQUEST_CHUNK_SIZE: 30
		}
	}
}

WhooosReadingUtility.Constants.TITLES = WhooosReadingUtility.Constants.BASE_TITLES.concat(
	WhooosReadingUtility.Constants.BASE_TITLES.map(function(title) {
		return title.replace(".", "");
	})
);

WhooosReadingUtility.Constants.PERIOD_TO_NAME = {};
Object.values(WhooosReadingUtility.Constants.PERIODS).map((period) => {
	WhooosReadingUtility.Constants.PERIOD_TO_NAME[period] = period.split("-").join(" ");
});


function displayAlert(title, text) {
	if (window.wrNotifications) {
		window.wrNotifications.triggerDropDownNotification({ title: title,
			text: text, icon: "exclamation-sign", type: "error" }, 6000);

	} else {
		alert(title + ": " + text);
	}
}

module.exports = WhooosReadingUtility;



// WEBPACK FOOTER //
// ./modules/lib/shared/WhooosReadingUtility.js